module.exports = __webpack_public_path__ + "static/media/Forsidebilde_BifrostBooking.2230b16e.svg";